import { ExternalNotesComponent } from "./external-notes.component";
export var ExternalNotesModule = angular
    .module('externalNotes', [])
    .component(ExternalNotesComponent.selector, ExternalNotesComponent.component)
    .value('EventEmitter', function (payload) { return ({ $event: payload }); })
    .name;
//# sourceMappingURL=external-notes.module.js.map